import { GetStaticPaths } from 'next';
import { graphqlClient } from '../services';
import CategoryPage, {
  getStaticProps,
} from './[categorySlugOrTime]/strana/[pageNumber]';
import { AllCategoriesDocument, AllCategoriesQuery } from '../queries.graphql';

export default CategoryPage;

export { getStaticProps };

export const getStaticPaths: GetStaticPaths<{
  categorySlugOrTime: string;
  pageNumber?: string;
}> = async function getStaticPaths() {
  const result = await graphqlClient.request<AllCategoriesQuery>(
    AllCategoriesDocument,
  );

  const rootPaths: { categorySlugOrTime: string }[] = [];

  for (const category of result.articleCategories) {
    if (category.articles.length === 0) {
      // eslint-disable-next-line no-continue
      continue; // skip empty category
    }

    rootPaths.push({ categorySlugOrTime: category.slug });
  }

  return {
    paths: rootPaths.map((params) => ({ params })),
    fallback: false,
  };
};
